<template>
  <div class="app">
    <CustomCursor />
    <nav-bar />
    <router-view />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>

<style>
:root {
  --background: #2F2E2E;
  --secondary-background: #454545;
  --accent: #8b7054;
  --accent-secondary: #6c553d;
  --text-primary: #D6D1CE;
  --text-secondary: #E6E1DE;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Halenoir', sans-serif;
  background-color: var(--background);
  color: var(--text-primary);
}

.app {
  min-height: 100vh;
}
</style>